const {
  POSITION_TYPE_CATEGORY_NAME,
  POSITION_TYPE_INTERNAL,
  POSITION_TYPE_INTERNAL_VALUE,
  POSITION_TYPE_INTERNAL_AND_EXTERNAL_VALUE
} = require("../../../components/pages/careers/careers-constants");

const getPublishCategoryValue = (position) => {
  const publishCategory = position?.categories.find((category) => category.name === POSITION_TYPE_CATEGORY_NAME);
  return publishCategory && publishCategory.value;
};

// filters positions by internal and external
const isPositionRelevantToType = (position, positionsType) => {
  const publishCategoryValue = getPublishCategoryValue(position);
  return publishedPositionFitsType(publishCategoryValue, positionsType);
};

const publishedPositionFitsType = (publishCategoryValue, requestedPositionsType) => {
  if (requestedPositionsType === POSITION_TYPE_INTERNAL && publishCategoryValue) {
    return (
      publishCategoryValue === POSITION_TYPE_INTERNAL_AND_EXTERNAL_VALUE ||
      publishCategoryValue === POSITION_TYPE_INTERNAL_VALUE
    );
  }

  // else - external. filter out only internal
  return !publishCategoryValue || publishCategoryValue !== POSITION_TYPE_INTERNAL_VALUE;
};

module.exports = {
  getPublishCategoryValue,
  isPositionRelevantToType,
  publishedPositionFitsType
};
